import { render, staticRenderFns } from "./quotations-new-prices.vue?vue&type=template&id=7df959f8&"
import script from "./quotations-new-prices.vue?vue&type=script&lang=js&"
export * from "./quotations-new-prices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports